import { Home, Detail } from "../pages/index";

export interface Props {
  path: string;
  auth?: boolean;
  exact?: boolean;
  strict?: boolean;
  // params?: any;
  isHide?: boolean;
  Component: React.ReactNode;
  isCheckRole?: boolean;
  title?: string;
}

const config: Array<Props> = [
  {
    path: "/",
    exact: true,
    strict: true,
    Component: Home,
  },
  {
    path: "/:id",
    exact: true,
    strict: true,
    Component: Detail,
  },
];

export default config;
